<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$http.post('/website/recruitment.htm', '').then(res => {
      if (res.data.resultCode === '0000') {
        if (res.data.data.list.length > 0) {
          sessionStorage.setItem('flag', true)
        } else {
          sessionStorage.setItem('flag', false)
        }
      } else {
        this.$Message.error(res.data.resultMsg)
        sessionStorage.setItem('flag', false)
      }
    })
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family:PingFangSC-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue